import CellServicer from './CellServicer';

export default CellServicer;
